import React, { useMemo } from 'react';
import jsonData from '../../signals/jsonData';
import appState from '../../signals/appState';
import translation from '../../signals/translations';
import IconClose from '../../icons/IconClose';
import IconShare from '../../icons/IconShare';

const RecommendedRoutes = () => {
	const { RecommendedRoutes: isOpen } = appState.value;
	const { recommendedRoutes, floorInfo } = jsonData.value;

	const groupedRoutes = useMemo(() => {
		if (!recommendedRoutes || !recommendedRoutes.length) return [];

		const routeMap = {};
		recommendedRoutes.forEach((row) => {
			const id = row['路線ID'];
			if (!routeMap[id]) {
				routeMap[id] = {
					id,
					name: row['路線名稱'] || '',
					description: row['路線簡介'] || '',
					image: row['路線圖片'] || '',
					stops: [],
				};
			}
			routeMap[id].stops.push(row);
		});

		return Object.values(routeMap).map((route) => {
			route.stops.sort((a, b) => Number(a['站序']) - Number(b['站序']));
			return route;
		});
	}, [recommendedRoutes]);

	const closePanel = () => {
		appState.value = {
			...appState.value,
			RecommendedRoutes: false,
		};
	};

	const activateRoute = (routeId) => {
		const route = groupedRoutes.find((r) => r.id === routeId);
		if (!route) return;

		// Find the first booth-type stop and switch to its floor
		const firstBoothStop = route.stops.find((s) => s['點位類型'] === '攤位');
		if (firstBoothStop) {
			const boothNumber = firstBoothStop['攤位號碼'];
			let targetFloor = 0;

			floorInfo.forEach((floor, index) => {
				if (floor.booths) {
					const found = floor.booths.find((b) => b.linked === boothNumber || b.exhibitor?.['攤位號碼'] === boothNumber);
					if (found) targetFloor = index;
				}
			});

			appState.value = {
				...appState.value,
				activeRoute: routeId,
				activeFloor: targetFloor,
				RecommendedRoutes: false,
				MobileMenu: false,
				navigation: false,
				selectedBooth: null,
			};
		} else {
			// Fallback: use floor from first floor passage stop
			const firstPassage = route.stops.find((s) => s['點位類型'] === '樓層通道' && s['樓層']);
			let targetFloor = 0;
			if (firstPassage) {
				floorInfo.forEach((floor, index) => {
					if (String(floor.floor) === String(firstPassage['樓層'])) targetFloor = index;
				});
			}

			appState.value = {
				...appState.value,
				activeRoute: routeId,
				activeFloor: targetFloor,
				RecommendedRoutes: false,
				MobileMenu: false,
				navigation: false,
				selectedBooth: null,
			};
		}
	};

	const openSharePopup = (e, route) => {
		e.stopPropagation();
		appState.value = {
			...appState.value,
			RouteSharePopup: route,
		};
	};

	if (!isOpen) return null;

	return (
		<div id='RecommendedRoutes' className={isOpen ? 'active' : ''}>
			<IconClose onClick={closePanel} />
			<div className='panel-heading'>{translation('leftPanel.recommendedRoutes')}</div>
			<div className='panel-body'>
				{groupedRoutes.length === 0 ? (
					<div className='empty-state'>No routes available</div>
				) : (
					groupedRoutes.map((route) => (
						<div className='route-card' key={route.id} onClick={() => activateRoute(route.id)}>
							<div className='route-image'>
								{route.image ? (
									<img src={route.image} alt={route.name} />
								) : (
									<div className='route-image-placeholder'>
										<span className='material-symbols-rounded'>route</span>
									</div>
								)}
							</div>
							<div className='route-content'>
								<div className='route-title'>
									<span>{route.name}</span>
									<IconShare onClick={(e) => openSharePopup(e, route)} />
								</div>
								<div className='route-description'>{route.description}</div>
							</div>
						</div>
					))
				)}
			</div>
		</div>
	);
};

export default RecommendedRoutes;
